import { gql } from '@apollo/client';
import { CbPromoCodeFields, CbPromoCodeRedemptionFields } from './fragments';

export const GET_CB_PROMO_CODES = gql`
  query GetCbPromoCodes($input: GetCbPromoCodesInput!) {
    getCbPromoCodes(input: $input) {
      entities {
        ...CbPromoCodeFields
      }
      total
      offset
      limit
    }
  }
  ${CbPromoCodeFields}
`;

export const GET_CB_PROMO_CODE = gql`
  query GetCbPromoCode($id: String!) {
    getCbPromoCode(id: $id) {
      ...CbPromoCodeFields
    }
  }
  ${CbPromoCodeFields}
`;

export const GET_CB_PROMO_CODE_REDEMPTIONS = gql`
  query GetCbPromoCodeRedemptions($input: GetCbPromoCodeRedemptionsInput!) {
    getCbPromoCodeRedemptions(input: $input) {
      entities {
        ...CbPromoCodeRedemptionFields
      }
      total
      offset
      limit
    }
  }
  ${CbPromoCodeRedemptionFields}
`;

export const ADMIN_GET_CB_SUBSCRIPTION_PRODUCTS = gql`
  query AdminGetCbSubscriptionProducts {
    adminGetCbSubscriptionProducts {
      id
      name
      description
      type
      subType
      isPublic
      isMostPopular
      orderIndex
      prices {
        id
        name
        type
        subType
        unitAmount
        monthlyEquivalentPrice
        recurringInterval
        recurringIntervalCount
        isPublic
        active
      }
    }
  }
`;
